import { useEffect as r } from "react";
import { useTheme as c } from "./useTheme.es.js";
import { getFontFaces as m } from "./utils.es.js";
function a() {
  const e = c();
  return r(() => {
    var o;
    const n = m((o = e.typography) == null ? void 0 : o.fontFaces, e.publicUrl), t = document.createElement("style");
    return t.innerText = n, document.head.appendChild(t), () => {
      document.head.removeChild(t);
    };
  }, [e]), null;
}
export {
  a as FontLoader
};
//# sourceMappingURL=FontLoader.es.js.map
